/* eslint-disable no-useless-escape */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-undef */
import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
  Spinner,
  Stack,
  StackDivider,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { MdDateRange, MdOutlineEmail, MdPhone } from 'react-icons/md';
import { auth } from '../../Config/firebase';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { updatePassword } from '@firebase/auth';
import {
  addDocumentFirebase,
  deleteFileFirebase,
  getSingleDocumentFirebase,
  updateProfileFirebase,
  UploadBlob,
  updateDocumentFirebase,
} from '../../Api/firebaseApi';
import useUserStore from '../../Hooks/Zustand/Store';
import BillingsPage from '../Configuration/Billings/BillingsPage';

export const SettingAccountPage = () => {
  const globalState = useUserStore();
  const [data, setData] = useState({});
  const [userData, setUserData] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [show, setShow] = useState({ password: false, confirmPassword: false });
  const [input, setInput] = useState({ password: null, confirmPassword: null });

  const [loading, setLoading] = useState(false);


  const user = auth.currentUser;
  const toast = useToast();

  const handleClick = (type) => {
    if (type === 'password') {
      setShow({ ...show, password: !show.password });
    } else {
      setShow({ ...show, confirmPassword: !show.confirmPassword });
    }
  };

  const getUserData = async () => {
    try {
      const result = await getSingleDocumentFirebase('users', globalState.uid);
      setUserData(result);
    } catch (error) {
      toast({
        title: 'Deoapp.com',
        duration: 3000,
        description: error.message,
        status: 'error',
        position: 'top-right',
        isClosable: true,
      });
    }
  };

  const handleUpdate = async () => {
    setLoading(true);

    const collectionName = 'users';
    const docName = globalState?.uid;

    try {
      await updateProfileFirebase(data);

      await updateDocumentFirebase(collectionName, docName, data);

      await addDocumentFirebase(
        'logs',
        {
          activity: 'update user profile',
          uid: globalState?.uid,
          projectId: globalState?.currentProject,
        },
        globalState.currentCompany
      );
      toast({
        title: 'Success',
        description: 'Success update data!',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: 'Deoapp.com',
        duration: 3000,
        description: error.message,
        status: 'error',
        position: 'top-right',
        isClosable: true,
      });
    } finally {
      setLoading(false);
      getUserData();
    }
  };

  const handleUploadThumbnail = async (file) => {
    const collectionName = 'users';
    const docName = globalState.uid;

    setIsUploading(true);
    UploadBlob(file, 'profile', user?.uid, file.name, setIsUploading).then(
      async (uploadedImg) => {
        updateProfileFirebase({
          photoURL: uploadedImg.url.replace(/(\.[^.\/\\]+)$/i, '_800x800$1'),
        });

        const data = {
          image: uploadedImg.url.replace(/(\.[^.\/\\]+)$/i, '_800x800$1'),
        };

        await updateDocumentFirebase(collectionName, docName, data);

        setIsUploading(false);
      }
    );

    await addDocumentFirebase(
      'logs',
      {
        activity: 'upload user photo',
        uid: globalState.uid,
        projectId: globalState.currentProject,
      },
      globalState.currentCompany
    );
  };

  const inputStyles = {
    '&::placeholder': {
      color: 'gray.500',
    },
  };

  const handleDeletePhoto = async () => {
    const splitArr = user?.photoURL.split('?');
    // console.log(splitArr, "splitarr");
    const splitSecond = splitArr[0].split('%2F');
    setIsUploading(true);
    deleteFileFirebase('profile', user?.uid, splitSecond[2]).then(() => {
      updateProfileFirebase({ photoURL: '' }).then(() => {
        setIsUploading(false);
      });
    });

    await addDocumentFirebase(
      'logs',
      {
        activity: 'delete user photo',
        uid: globalState.uid,
        projectId: globalState.currentProject,
      },
      globalState.currentCompany
    );
  };

  const handleUpdatePassword = () => {
    if (
      input.password === null ||
      input.password === '' ||
      Input.confirmPassword === null ||
      Input.confirmPassword === ''
    ) {
      toast({
        title: 'Error',
        description: 'Fields are required!',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    } else if (input.password === input.confirmPassword) {
      updatePassword(user, input.password)
        .then(() => {
          toast({
            title: 'Success',
            description: 'Password has been edited!',
            status: 'success',
            duration: 9000,
            isClosable: true,
          });
        })
        .catch((error) => {
          toast({
            title: error.code,
            description: error.message,
            status: 'error',
            duration: 9000,
            isClosable: true,
          });
        });
    } else {
      toast({
        title: 'Error',
        description: 'Password did not match!',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
  };



  useEffect(() => {
    return () => {};
  }, [isUploading]);

  useEffect(() => {
    getUserData();
    return () => {};
  }, []);

  return (
    <Flex gap={4} direction={['column-reverse', 'row', 'row']} pb={10}>
      <Box
        w={['100%', '80%', '80%']}
        borderTopWidth={3}
        borderColor="green.500"
        py={4}
        px={2}
        borderRadius="md"
        shadow="md"
      >
        <Tabs variant="enclosed">
          <TabList>
            <Tab>
              {('Edit')} {('profile')}
            </Tab>
            <Tab>{('Change Password')}</Tab>
            <Tab>{('Billing')}</Tab>

            {/* <Tab>Team</Tab> */}
          </TabList>
          <TabPanels>
            <TabPanel>
              <Box
                as="section"
                py={{
                  base: '4',
                  md: '8',
                }}
              >
                <Stack spacing={5}>
                  <FormControl id="name">
                    <Stack
                      direction={{
                        base: 'column',
                        md: 'row',
                      }}
                      spacing={{
                        base: '1.5',
                        md: '8',
                      }}
                      justify="space-between"
                    >
                      <FormLabel variant="inline">{('Name')}</FormLabel>
                      <Input
                        // bgColor="white"
                        sx={inputStyles}
                        resize="none"
                        onChange={(e) =>
                          setData({
                            ...data,
                            displayName: e.target.value,
                            name: e.target.value,
                          })
                        }
                        maxW={{
                          md: '3xl',
                        }}
                        defaultValue={
                          userData?.displayName
                            ? userData?.displayName
                            : userData?.name
                        }
                      />
                    </Stack>
                  </FormControl>

                  <FormControl id="email">
                    <Stack
                      direction={{
                        base: 'column',
                        md: 'row',
                      }}
                      spacing={{
                        base: '1.5',
                        md: '8',
                      }}
                      justify="space-between"
                    >
                      <FormLabel variant="inline">Email</FormLabel>
                      <Input
                        // bgColor="white"
                        sx={inputStyles}
                        resize="none"
                        type="email"
                        disabled
                        maxW={{
                          md: '3xl',
                        }}
                        defaultValue={userData?.email ? userData?.email : ''}
                      />
                    </Stack>
                  </FormControl>

                  <FormControl id="phone">
                    <Stack
                      direction={{
                        base: 'column',
                        md: 'row',
                      }}
                      spacing={{
                        base: '1.5',
                        md: '8',
                      }}
                      justify="space-between"
                    >
                      <FormLabel variant="inline">{('Phone Number')}</FormLabel>
                      <InputGroup
                        maxW={{
                          md: '3xl',
                        }}
                      >
                        <InputLeftAddon children="+62" />
                        <Input
                          // bgColor="white"
                          sx={inputStyles}
                          resize="none"
                          type="number"
                          onChange={(e) =>
                            setData({
                              ...data,
                              phoneNumber: e.target.value,
                            })
                          }
                          defaultValue={
                            userData?.phoneNumber ? userData?.phoneNumber : ''
                          }
                        />
                      </InputGroup>
                    </Stack>
                  </FormControl>
                </Stack>
                <Box my={4} align={'right'}>
                  <Button
                    colorScheme="green"
                    isLoading={loading}
                    onClick={() => handleUpdate()}
                  >
                    {('save')}
                  </Button>
                </Box>
              </Box>
            </TabPanel>

            <TabPanel>
              <Box
                as="section"
                py={{
                  base: '4',
                  md: '8',
                }}
              >
                <Stack spacing="5">
                  <Stack
                    spacing="4"
                    direction={{
                      base: 'column',
                      sm: 'row',
                    }}
                    justify="space-between"
                  >
                    <Box>
                      <Text fontSize="lg" fontWeight="medium">
                        {('Password')}
                      </Text>
                      <Text color="muted" fontSize="sm">
                        {('change password')}
                      </Text>
                    </Box>
                  </Stack>
                  <Divider />
                  <Stack spacing="5" divider={<StackDivider />}>
                    <FormControl id="name" isRequired>
                      <Stack
                        direction={{
                          base: 'column',
                          md: 'row',
                        }}
                        spacing={{
                          base: '1.5',
                          md: '8',
                        }}
                        justify="space-between"
                      >
                        <FormLabel
                          variant="inline"
                          w={{ base: '100%', md: '30%' }}
                        >
                          {('Password')}
                        </FormLabel>
                        <InputGroup size="md">
                          <Input
                            // bgColor="white"
                            color="black"
                            sx={inputStyles}
                            resize="none"
                            pr="4.5rem"
                            type={show.password ? 'text' : 'password'}
                            placeholder={('Enter Password')}
                            onChange={(e) =>
                              setInput({ ...input, password: e.target.value })
                            }
                          />
                          <InputRightElement width="4.5rem">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => handleClick('password')}
                            >
                              {show.password ? <FiEye /> : <FiEyeOff />}
                            </Button>
                          </InputRightElement>
                        </InputGroup>
                      </Stack>
                    </FormControl>
                    <FormControl id="name" isRequired>
                      <Stack
                        direction={{
                          base: 'column',
                          md: 'row',
                        }}
                        spacing={{
                          base: '1.5',
                          md: '8',
                        }}
                        justify="space-between"
                      >
                        <FormLabel
                          variant="inline"
                          w={{ base: '100%', md: '30%' }}
                        >
                          {('Confirm Password')}
                        </FormLabel>
                        <InputGroup size="md">
                          <Input
                            // bgColor="white"
                            color="black"
                            sx={inputStyles}
                            resize="none"
                            pr="4.5rem"
                            type={show.confirmPassword ? 'text' : 'password'}
                            placeholder={('Entre Password')}
                            onChange={(e) =>
                              setInput({
                                ...input,
                                confirmPassword: e.target.value,
                              })
                            }
                          />
                          <InputRightElement width="4.5rem">
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => handleClick('confirmPassword')}
                            >
                              {show.confirmPassword ? <FiEye /> : <FiEyeOff />}
                            </Button>
                          </InputRightElement>
                        </InputGroup>
                      </Stack>
                    </FormControl>
                    <Flex direction="row-reverse">
                      <Button
                        onClick={() => handleUpdatePassword()}
                        colorScheme="green"
                      >
                        {('Save')}
                      </Button>
                    </Flex>
                  </Stack>
                </Stack>
              </Box>
            </TabPanel>

            <TabPanel>
              <BillingsPage />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>

      <Box
        w={['100%', '20%', '30%']}
        spacing={2}
        borderTopWidth={3}
        borderColor="green.500"
        py={4}
        px={2}
        borderRadius="md"
        shadow="md"
      >
        <Heading mt={2} mb={4} align={'center'}>
          {('Profile')}
        </Heading>

        <Box align={'center'}>
          <Stack justifyContent={'center'} alignItems={'center'} my={5}>
            {/* <Avatar size="lg" name={userData?.name} src={user.photoURL} /> */}
            {isUploading ? (
              <Spinner />
            ) : (
              <Avatar
                size="lg"
                name={user.email}
                src={
                  user?.photoURL === null ||
                  user?.photoURL?.includes('example.com')
                    ? `https://api.dicebear.com/7.x/adventurer/svg?seed=${user.email}`
                    : user?.photoURL
                }
              />
            )}

            {user?.photoURL !== null ? (
              <Button size="xs" colorScheme="red" onClick={handleDeletePhoto}>
                {('Delete')}
              </Button>
            ) : (
              <Input
                my={3}
                // as={Text}
                size={'sm'}
                type="file"
                variant={'unstyled'}
                onChange={(e) => handleUploadThumbnail(e.target.files[0])}
              />
            )}
          </Stack>

          <Box my={5} px={4}>
            <Heading size={'md'}>
              {userData?.displayName || userData?.name}
            </Heading>

            <Stack my={3} spacing={4}>
              <HStack>
                <Icon as={MdOutlineEmail} />
                <Text>{userData?.email}</Text>
              </HStack>
              <HStack>
                <Icon as={MdPhone} />
                <Text>{userData?.phoneNumber}</Text>
              </HStack>
              <HStack>
                <Icon as={MdDateRange} />
                <Text>
                  {new Date(userData?.lastUpdated?.toDate()).toLocaleString()}
                </Text>
              </HStack>
              <HStack>
                <Icon />
                <Text>
                  {new Date(userData?.lastUpdated?.toDate()).toLocaleString()}
                </Text>
              </HStack>
            </Stack>
          </Box>
        </Box>

      </Box>
    </Flex>
  );
};
